module.exports = __webpack_public_path__ + "static/media/hs_10.5609acd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_10.jpg
// module id = 5941
// module chunks = 0